import {
  MailFilled,
  MailOutlined,
  PhoneFilled,
  PhoneOutlined,
} from '@ant-design/icons'
import { Space, Switch } from 'antd'
import { Header } from 'antd/es/layout/layout'
import { memo, useEffect, useState } from 'react'
import logo from '../images/logo_bianco.png'
import './../App.css'
import locales from '../locales/locale'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

const Menu = ({
  setLang,
  lang,
}: {
  setLang: React.Dispatch<React.SetStateAction<string>>
  lang: string
}): JSX.Element => {
  const [isFixed, setIsFixed] = useState(false)

  const { pathname } = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      setIsFixed(scrollTop > 0) // Imposta isFixed a true se lo scroll è maggiore di 0
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  const isFixedClassName = isFixed || pathname !== '/' ? 'is-fixed' : ''

  return (
    <Header id="header" className={isFixedClassName}>
      <div className={`info-menu ${isFixedClassName}`}>
        <div style={{ float: 'right' }}>
          <Space
            style={{
              borderRight: '1px #ffffff3d solid',
              padding: '0 1vw',
            }}
            size={'small'}
          >
            <PhoneOutlined />
            <a href="tel:+420606082404" style={{ color: 'white' }}>
              +420 606082404
            </a>
          </Space>
          <Space
            style={{
              padding: '0 1vw',
            }}
            size={'small'}
          >
            <MailOutlined />
            <a href="mailto:info@zefiroint.com" style={{ color: 'white' }}>
              info@zefiroint.com
            </a>
          </Space>
        </div>
      </div>
      <Link to="/">
        <Space
          direction="horizontal"
          className="menu-items"
          // align="start"
          style={{
            padding: 8,
            color: isFixed || pathname !== '/' ? 'black' : 'white',
          }}
        >
          <img src={logo} alt="Sfondo" className={`logo ${isFixedClassName}`} />
          <div className="text-logo">
            <span>efiro</span>
          </div>
        </Space>
      </Link>
      <Space className={`lingua ${isFixedClassName}`}>
        <a href="tel:+420606082404">
          <PhoneFilled />
        </a>
        <a href="mailto:info@zefiroint.com">
          <MailFilled />
        </a>
        <Switch
          checked={lang === 'en'}
          onChange={(language) => {
            setLang(language ? 'en' : 'cs')
            locales.setLanguage(language ? 'en' : 'cs')
          }}
          checkedChildren="EN"
          unCheckedChildren="CS"
        />
      </Space>
    </Header>
  )
}

export default memo(Menu)
